export const AttributeNameSanitizerExpression = RegExp(/[^a-zA-Z0-9\s]+/g);
export const EmptyHeaderNameExpression = RegExp("^__EMPTY(_[0-9]{1,})?$", "i");
export const KEY_COLUMN_FIELD = "Code/ID";
export const ALTERNATIVE_KEY_COLUMN_FIELD = "ID";
export const NOTES_COLUMN_FIELD = "Notes";
export const IN_ASSORTMENT_FIELD = "In Assortment";
export const NAME_FIELD = "Name";
export const READ_ONLY_COLUMNS = [KEY_COLUMN_FIELD, IN_ASSORTMENT_FIELD, NAME_FIELD, NOTES_COLUMN_FIELD];
export const BLANK_VALUE = "";
